import './style';
import App from './components/app';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.core.css';
import 'react-toastify/dist/ReactToastify.min.css';

export default App;
